
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 6a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-3 0v-9A1.5 1.5 0 019 6zm6 0a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-3 0v-9A1.5 1.5 0 0115 6z","fill-rule":"evenodd"}})])
          )
        }
      }
    